import React from "react";

import classNames from "classnames";

export function TournamentHeaderCollapseIndicator(props: {
	setHidden: (value: boolean) => void;
	hidden: boolean;
	isAdditionalOfferVisible?: boolean;
}) {
	const { setHidden, hidden, isAdditionalOfferVisible } = props;

	const toggleClasses = classNames("offer__head__data offer__toggle", {
		"offer__toggle--sml": isAdditionalOfferVisible,
	});

	const iconIndicatorClasses = classNames(
		"offer__toggle__icon u-icon u-icon--tny",
		{
			"u-icon--caret--down": !hidden,
			"u-icon--caret--right": hidden,
		}
	);

	return (
		<div className={toggleClasses}>
			<button
				type="button"
				className="offer__toggle__btn btn btn--square btn--square--xsml btn--ghost"
				onClick={() => setHidden(!hidden)}
			>
				<i className={iconIndicatorClasses} />
			</button>
		</div>
	);
}
